/**
 * @generated SignedSource<<eb7a7077495bb720961975b71580bf9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SeoRouteEditPageQuery$variables = {
  id: string;
};
export type SeoRouteEditPageQuery$data = {
  readonly seoRoute: {
    readonly " $fragmentSpreads": FragmentRefs<"MediaEditor_mediable" | "SeoRouteEditForm_seoRoute" | "SeoRouteEditSeo_seoRoute" | "SeoRouteEditStats_seoRoute" | "SeoRouteSidebar_seoRoute">;
  } | null;
};
export type SeoRouteEditPageQuery = {
  response: SeoRouteEditPageQuery$data;
  variables: SeoRouteEditPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 2147483647
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "SeoRouteEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SeoRoute",
        "kind": "LinkedField",
        "name": "seoRoute",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteSidebar_seoRoute"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteEditForm_seoRoute"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteEditSeo_seoRoute"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "MediaEditor_mediable"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SeoRouteEditStats_seoRoute"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "SeoRouteEditPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SeoRoute",
        "kind": "LinkedField",
        "name": "seoRoute",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "SeoRouteJsonParam",
            "kind": "LinkedField",
            "name": "jsonParams",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "sourceUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "targetUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "metaDescription",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "h1",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "promoText",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "promoLinkTitle",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "promoLinkUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SeoRouteStat",
            "kind": "LinkedField",
            "name": "stats",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "week",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "sourceViews",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "destinationViews",
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "uuid",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "createdAt",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "updatedAt",
                "storageKey": null
              }
            ],
            "type": "Entity",
            "abstractKey": "__isEntity"
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v4/*: any*/),
                "concreteType": "MediaConnection",
                "kind": "LinkedField",
                "name": "media",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "MediaEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Media",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          },
                          (v3/*: any*/),
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "S120X120"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "externalUrl",
                            "storageKey": "externalUrl(size:\"S120X120\")"
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Literal",
                                "name": "size",
                                "value": "w262"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "src",
                            "storageKey": "src(size:\"w262\")"
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "kind": "ClientExtension",
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__id",
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "media(first:2147483647)"
              },
              {
                "alias": null,
                "args": (v4/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "MediaEditor_mediable_media",
                "kind": "LinkedHandle",
                "name": "media"
              }
            ],
            "type": "Mediable",
            "abstractKey": "__isMediable"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ae0e235d07ec20f775f4ebff84285544",
    "id": null,
    "metadata": {},
    "name": "SeoRouteEditPageQuery",
    "operationKind": "query",
    "text": "query SeoRouteEditPageQuery(\n  $id: ID!\n) {\n  seoRoute(id: $id) {\n    ...SeoRouteSidebar_seoRoute\n    ...SeoRouteEditForm_seoRoute\n    ...SeoRouteEditSeo_seoRoute\n    ...MediaEditor_mediable\n    ...SeoRouteEditStats_seoRoute\n    id\n  }\n}\n\nfragment EntitySidebar_entity on Entity {\n  __isEntity: __typename\n  uuid\n  createdAt\n  updatedAt\n}\n\nfragment MediaEditorPreviews_media on MediaConnection {\n  edges {\n    node {\n      id\n      ...MediaEditorThumb_media\n    }\n  }\n}\n\nfragment MediaEditorSort_media on MediaConnection {\n  edges {\n    node {\n      id\n    }\n  }\n}\n\nfragment MediaEditorThumb_media on Media {\n  id\n  ...MediaThumb_media\n}\n\nfragment MediaEditor_mediable on Mediable {\n  __isMediable: __typename\n  id\n  media(first: 2147483647) {\n    edges {\n      node {\n        id\n        __typename\n      }\n      cursor\n    }\n    ...MediaEditorPreviews_media\n    ...MediaEditorSort_media\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment MediaThumb_media on Media {\n  type\n  externalUrl(size: S120X120)\n  src(size: w262)\n}\n\nfragment SeoRouteEditForm_seoRoute on SeoRoute {\n  id\n  type\n  sourceUrl\n  targetUrl\n}\n\nfragment SeoRouteEditSeo_seoRoute on SeoRoute {\n  id\n  metaTitle\n  metaDescription\n  h1\n  promoText\n  promoLinkTitle\n  promoLinkUrl\n}\n\nfragment SeoRouteEditStats_seoRoute on SeoRoute {\n  stats {\n    week\n    sourceViews\n    destinationViews\n    id\n  }\n}\n\nfragment SeoRouteJsonParams_seoRoute on SeoRoute {\n  jsonParams {\n    name\n    value\n  }\n}\n\nfragment SeoRouteSidebar_seoRoute on SeoRoute {\n  jsonParams {\n    name\n  }\n  ...EntitySidebar_entity\n  ...SeoRouteJsonParams_seoRoute\n}\n"
  }
};
})();

(node as any).hash = "f8f014ffd7cdbee54c3a993e8278747a";

export default node;
